import {
  AUTH,
  LOGIN_USER,
  LOGIN_FAILED,
  LOGOUT_USER,
  UPDATE_MESSAGE,
} from "../actions/types";

const initial_state = {
  user: null,
  success_message: "",
  fail_message: "",
  has_logged_in: null,
  alert: "",
};

// step 3 define reducers use module.exports for reducers,
function AuthReducer(state = initial_state, action) {
  switch (action.type) {
    case LOGIN_FAILED:
      return {
        user: null,
        fail_message: action.payload.fail_message,
        has_logged_in: false,
      };
    case AUTH:
      return {
        user: action.payload.user,
        alert: action.payload.alert,
      };
    case LOGIN_USER:
      return {
        user: action.payload.data,
        fail_message: action.payload.error,
        has_logged_in: action.payload.has_logged_in,
        alert: action.payload.alert,
      };
    case LOGOUT_USER:
      return {
        user: null,
      };
    case UPDATE_MESSAGE:
      console.log(action);
      return {
        ...state,
        success_message: action.payload.success_message || "",
        fail_message: action.payload.fail_message || "",
      };
    default:
      return state;
  }
}

export default AuthReducer;



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js